/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/h5': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M11.176 17.96H9.084v-5.37H3.681v5.37h-2.1V5.874h2.1v5.03h5.403v-5.03h2.092V17.96zM14.882 11.967l.656-6.093h6.491v1.743h-4.814l-.332 2.889c.559-.321 1.19-.482 1.892-.482 1.151 0 2.045.368 2.681 1.104.643.736.963 1.727.963 2.972 0 1.229-.354 2.208-1.062 2.939-.708.724-1.68 1.087-2.914 1.087-1.106 0-2.025-.313-2.756-.938-.724-.63-1.117-1.46-1.178-2.49h1.95c.078.586.288 1.037.631 1.353.343.31.792.465 1.345.465.62 0 1.101-.222 1.444-.664.349-.443.523-1.046.523-1.81 0-.736-.19-1.317-.572-1.743-.382-.432-.908-.648-1.578-.648-.365 0-.675.05-.93.15-.254.094-.53.282-.83.564l-1.61-.398z" _fill="currentColor"/>'
  }
})
